/**
 * @file Checks that a value is an ISO date-time string with a time and a zone.
 */
const DATETIME_REGEX = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2}))$/;

// The pattern comes from
// https://stackoverflow.com/questions/52869695/check-if-a-date-string-is-in-iso-and-utc-format
/**
 * Checks that the value is a string in the ISO date-time format, with a time and a zone,
 * and that it is a valid date.
 */
const isIsoDateTime = (value: unknown): boolean => {
  const isString = typeof value === "string";

  if (!isString) {
    return false;
  }

  const hasIsoFormat = DATETIME_REGEX.test(value);

  if (!hasIsoFormat) {
    return false;
  }

  const date = new Date(value);

  const isValidDate = !Number.isNaN(date.getTime());

  return isValidDate;
};

export default isIsoDateTime;
